import Vue from "vue";
import { mapActions, mapGetters } from "vuex";
import priceFormatter from "@/utility/priceFormatter";
import Variable from "../Variable.vue";
export default Vue.extend({
    components: { Variable },
    props: {
        salaryRow: {},
        salaryRowDetails: {},
    },
    data() {
        return {
            headers: [
                {
                    text: "Calculation basis",
                    value: "description",
                    sortable: false,
                },
                {
                    text: "Value",
                    value: "value",
                    align: "right",
                    sortable: false,
                },
            ],
        };
    },
    filters: {},
    methods: {
        ...mapActions("variableSalaryModal", ["setHoveredVariable"]),
        hoveredClass(target) {
            if (target === this.hoveredVariable) {
                return "hovered";
            }
        },
        toSek(number) {
            return priceFormatter.fromNumber(number).toStringSEK() || 0;
        },
    },
    computed: {
        ...mapGetters("variableSalaryModal", ["hoveredVariable"]),
        items() {
            return [
                {
                    description: "Hours in month",
                    value: `${this.salaryRowDetails.availableHours} h`,
                },
                {
                    description: "Billable hours",
                    value: `${this.salaryRowDetails.billableHours} h`,
                },
                {
                    description: "Additions",
                    value: this.toSek(this.salaryRow.additions),
                },
                {
                    description: "Variable rate",
                    value: `${this.salaryRowDetails.levelPayRate} kr/h`,
                },
                {
                    description: "Variable cutoff",
                    value: `${this.salaryRowDetails.monthlyHourLimit} h`,
                },
                {
                    description: "Vacation",
                    value: `${this.salaryRowDetails.vacationHours} h`,
                },
                {
                    description: "Long term absence",
                    value: `${this.salaryRowDetails.longTermAbsenceHours} h`,
                },
            ];
        },
    },
});
